

import "./bootstrap/cleanConsole";
import React from "react";
import ReactDOM from "react-dom/client";
import "./bootstrap/patchApiBase";
import App from "./App";
import "./styles/ibm-plex-sans-fonts.css";
import "./styles/professional-colors.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
